import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export const NoAccess = () => {
  const m = useMessages(messages)
  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="flex size-14 items-center justify-center rounded-full bg-muted">
          <ShieldAlert className="size-7 text-muted-foreground" />
        </div>
        <h1 className="text-2xl font-semibold">{m.noAccess}</h1>
        <p className="text-muted-foreground">{m.noAccessHint}</p>
        <Button asChild>
          <Link to="/">{m.toHome}</Link>
        </Button>
      </div>
    </div>
  )
}
